<template>
    <div>
        <p class="qs-500 message-body" :class="[ { '': mine }, { 'tw-text-black': !mine }, ]" v-html="body" ></p>
        <div class="tw-max-w-xs tw-mb-2 message-attachments">
            <div v-for="file in message.attachments" :key="file.id" class="tw-relative tw-py-6 tw-px-6 tw-rounded tw-bg-white tw-mt-2 hover:tw-bg-gray-0 bg-gray-0">
                <a class="tw-absolute tw-w-full tw-h-full tw-top-0 tw-left-0" :href="'https://cdn.thehuddle-aws.com/' + file.filepath" target="_blank"></a>
                <div class="tw-flex tw-justify-center tw-items-center">
                    <i class="far fa-file-alt tw-text-4xl tw-text-gray-600 tw-fill-current tw-mr-6"></i>
                    <div class=" tw-mr-6 tw-text-left">
                        <div class="tw-font-bold">{{ truncatedName(file.title) }}</div>
                    </div>
                    <div class="tw-bg-blue-500 tw-text-white tw-rounded tw-py-2 tw-px-6 tw-font-bold">
                        Download
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
	name: 'MessageFile',
	props: ['mine', 'message', 'body'],
	methods: {
		truncatedName(name) {
			// strip html tags from the body
			let regex = /(<([^>]+)>)/ig;
			const replacedName = name.replace(regex, ' ');

			// return truncated text when message is longer than 30 char, else return complete text
			return replacedName.length > 15 ? replacedName.slice(0, 15) + '...' : replacedName;
		}
	}
};
</script>

<style lang="scss" scoped>
    $light-blue: #D3EAFD;

    .message-attachments {
        i {
            font-size: 2rem !important;
        }
    }

    .message-mine {
        background-color:$light-blue;
        color:#1A1301;
    }
</style>
